<template>
  <selectable-card
    :selected="selected"
    @click:card="cardClicked"
    @click:checkbox="checkboxClicked"
    @click:more="moreClicked"
  >
    <template v-slot:content>
      <v-container class="text-body-2 text-uppercase">
        <v-row align="start">
          <v-col>
            <div>Guia</div>
            <div><b>{{ faturamentoGuia.numeroGuiaPrestador }}</b></div>
          </v-col>

          <v-col>
            <div>Itens</div>
            <div><b>{{ faturamentoGuia.quantidadeItens }}</b></div>
          </v-col>

          <v-col>
            <div>Lote</div>
            <div><b>{{ faturamentoGuia.lote.numeroLote }}</b></div>
          </v-col>

          <v-col>
            <v-chip v-if="associada" color="secondary" small>Associada</v-chip>
          </v-col>
        </v-row>

        <v-row align="start">
          <v-col class="py-0">
            <div>Beneficiário</div>
            <div v-if="faturamentoGuia.nomeBeneficiario"><b>{{ faturamentoGuia.nomeBeneficiario }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>

          <v-col class="py-0">
            <div>Carteirinha</div>
            <div v-if="faturamentoGuia.numeroCarteira"><b>{{ faturamentoGuia.numeroCarteira | formatNullValue }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0">
            <div>Senha</div>
            <div v-if="faturamentoGuia.senha"><b>{{ faturamentoGuia.senha | formatNullValue }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>
          
          <v-col class="py-0">
             <div>Guia Operadora</div>
             <div v-if="faturamentoGuia.numeroGuiaOperadora"><b>{{ faturamentoGuia.numeroGuiaOperadora | formatNullValue }}</b></div>
             <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
             <span v-else>-</span>
           </v-col>
           
          <v-col class="py-0">
            <div>Cronograma</div>
            <div v-if="faturamentoGuia.lote.cronograma.dataFaturamento"><b>{{ faturamentoGuia.lote.cronograma.dataFaturamento | formatDate | formatNullValue }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div>Informado</div>
            <div><b>{{ faturamentoGuia.valorTotal | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>Pago</div>
            <div class="success--text"><b>{{ faturamentoGuia.valorPago | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>Glosado</div>
            <div class="red--text"><b>{{ faturamentoGuia.valorGlosa | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>Saldo</div>
            <div><b>{{ saldo | formatCurrency }}</b></div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </selectable-card>
</template>

<script>
import { formatCurrency } from '../../../libs'
import SelectableCard from '../../common/SelectableCard.vue'

export default {
  components: {
    SelectableCard
  },
  props: {
    faturamentoGuia: { type: Object, required: true },
    isUsuarioTradimus: Boolean
  },
  computed: {
    selected () {
      return this.$store.getters['conciliacao/isFaturamentoGuiaSelected'](this.faturamentoGuia.id)
    },
    associada () {
      return this.$store.getters['conciliacao/isFaturamentoGuiaAssociada'](this.faturamentoGuia.id)
    },
    saldo () {
      var valorResult = this.faturamentoGuia.valorTotal - this.faturamentoGuia.valorPago - this.faturamentoGuia.valorAcatado
      return valorResult < 0 ? 0 : valorResult
    }
  },
  methods: {
    cardClicked () {
      this.$emit('click:card', this.faturamentoGuia, this.selected)
    },
    checkboxClicked () {
      this.$emit('click:checkbox', this.faturamentoGuia, this.selected)
    },
    moreClicked (event) {
      this.$emit('click:more', event)
    }
  },
  filters: {
    formatCurrency (value) {
      return formatCurrency(value)
    }
  }
}
</script>
